<template>
  <div class="template-status" :class="compactClass">
    <span class="template-status__icon" :class="status" :title="status"></span>
    <span v-if="!compact" class="template-status__text"><slot /></span>
  </div>
</template>

<script>
export default {
  name: 'AppStatus',

  props: {
    status: {
      type: String,
      required: true,
    },

    compact: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    compactClass() {
      return this.compact && 'compact'
    },
  },
}
</script>

<style scoped>
.template-status:not(.compact) {
  display: grid;
  grid-template-columns: 15px 70px;
  align-items: center;
  column-gap: 8px;
}

.template-status__icon {
  display: inline-block;
  content: '';
  height: 10px;
  width: 10px;
  border-radius: 100%;
  background-color: var(--c-gray-400);
  transition: var(--transition--default);
}

.template-status__icon.archived {
  background-color: var(--c-yellow-600);
}

.template-status__icon.published {
  width: 7px;
  height: 7px;
}

.template-status__icon.published {
  background-color: var(--c-aquamarine-600);
  box-shadow: 0 0 4px 2px var(--c-aquamarine-800);
}
</style>
